import { Chip, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useModuleAccess } from "../../context/ModuleAccess/ModuleAccessContext";

import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function TagsKanbanContainer({ ticket }) {
    const [tags, setTags] = useState([]);
    const [selected, setSelected] = useState("");
    const moduleAccess = useModuleAccess();
    const canAccessKanban = !moduleAccess.loading && !moduleAccess.error && moduleAccess.features.kanban?.allowed === true;

    useEffect(() => {
        let isMounted = true;
        if (!canAccessKanban) {
            setTags([]);
            setSelected("");
            return;
        }
        const loadTags = async () => {
            try {
                const { data } = await api.get("/tag/kanban/");
                if (!isMounted) return;
                const kanbanTags = data.lista || [];
                setTags(kanbanTags);
                const kanbanTagIds = new Set(kanbanTags.map((tag) => Number(tag.id)));
                const currentKanbanTag = (ticket.tags || []).find(
                    (tag) => Number(tag.kanban) === 1 || kanbanTagIds.has(Number(tag.id))
                );

                setSelected(currentKanbanTag?.id || "");
            } catch (err) {
                if (isMounted) toastError(err);
            }
        };
        loadTags();

        return () => {
            isMounted = false;
        };
    }, [canAccessKanban, ticket.tags]);

    const onChange = async (e) => {
        if (!canAccessKanban) return;
        const value = e.target.value;
        const previousValue = selected;
        const tagId = Number(value);

        if (!Number.isInteger(tagId) || tagId <= 0) {
            toastError("ERR_INVALID_KANBAN_STAGE");
            return;
        }

        setSelected(value);

        try {
            await api.put(`/ticket-tags/${ticket.id}/move-stage`, { tagId });
        } catch (err) {
            setSelected(previousValue);
            toastError(err);
        }
    };

    const renderSelectedValue = () => {
        const selectedTag = tags.find((tag) => Number(tag.id) === Number(selected));
        if (!selectedTag) return null;

        return (
            <Chip
                style={{
                    backgroundColor: selectedTag.color,
                    color: "#FFF",
                    marginRight: 1,
                    padding: 1,
                    fontWeight: "bold",
                    paddingLeft: 5,
                    paddingRight: 5,
                    borderRadius: 3,
                    fontSize: "0.8em",
                    whiteSpace: "nowrap",
                }}
                label={selectedTag.name}
                size="small"
            />
        );
    };

    if (!canAccessKanban) return null;

    return (
        <>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="tag-kanban-id">{i18n.t("Etapa Kanban")}</InputLabel>
                <Select
                    labelWidth={60}
                    value={selected}
                    labelId="tag-kanban-id"
                    label={i18n.t("Etapa Kanban")}
                    onChange={onChange}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                    }}
                    renderValue={renderSelectedValue}
                >
                    {tags.map((tag) => (
                        <MenuItem key={tag.id} value={tag.id}>
                            {tag.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}
